import React, {Component} from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import Registry from '../../../registry/index';

import JoinLeaveButton from '../JoinLeaveButtons/index'

import {
    SIDEBAR_LEFT_SHOW,
    SIDEBAR_RIGHT_SHOW,
    SIDEBAR_LEFT_HIDE,
    SIDEBAR_RIGHT_HIDE,
} from '../../../constants/sidebars';

class ContainerCenterHeader extends Component {
    state = { touchstart: null, touchend: null };

    onLeftBottomMenuClick = () => {
        let {dispatch} = this.props;
        dispatch({type: SIDEBAR_LEFT_SHOW});
    };

    onRightBottomMenuClick = () => {
        let {dispatch} = this.props;
        dispatch({type: SIDEBAR_RIGHT_SHOW});
    };

    handleTouchStart = event => {
        this.setState({ touchstart: event })
    };

    handleSwipe() {
        const { touchstart, touchend } = this.state;
        const { leftShown, rightShown, dispatch } = this.props;
        
        if (!touchstart || !touchend) return;
        const startX = touchstart.changedTouches[0].clientX;
        const endX = touchend.changedTouches[0].clientX;

        const moveRight = startX < endX;
        const longEnough =  Math.abs(startX - endX) > 100;

        const rightSidebarEnabled = window.screen.width < 766;

        if (longEnough) {
            if (moveRight) {
                if (rightShown) {
                    dispatch({type: SIDEBAR_RIGHT_HIDE});
                } else {
                    dispatch({type: SIDEBAR_LEFT_SHOW});
                }
            } else if (rightSidebarEnabled) {
                if (leftShown) {
                    dispatch({type: SIDEBAR_LEFT_HIDE});
                } else {
                    dispatch({type: SIDEBAR_RIGHT_SHOW});
                }
            }
        }
    }

    handleTouchEnd = event => {
        this.setState({ touchend: event });
        this.handleSwipe();
    };

    componentDidMount() {
        document.addEventListener('touchstart', this.handleTouchStart);
        document.addEventListener('touchend', this.handleTouchEnd);
    }

    componentWillUnmount() {
        document.removeEventListener('touchstart', this.handleTouchStart);
        document.removeEventListener('touchend', this.handleTouchEnd);
    }

    render() {
        const { visible, notifications } = this.props;
        let lang = Registry.get('locale'),
            mainRoomId = Registry.get('chatInterface').getDefaultRoomId(),
            {currentRoomInfo, currentRoomStayed, currentRoomActive, currentpmConversationNick, unreadpmConversationsPresent, currentPmOnlineStatusStr} = this.props;

        let classNames = [`block-room-name-no-dt ${!visible ? 'hidden' : ''} `];

        if (!isEmpty(currentRoomInfo)) {
            classNames.push("roomtype-" + currentRoomInfo.type);
        }

        return (
            <div className={classNames.join(" ")}>
                <div className="bottom-menu" onClick={this.onLeftBottomMenuClick}>
                    <div className={'icon-menu' + (unreadpmConversationsPresent ? ' pm-animated': '')} />
                </div>
                {!isEmpty(currentRoomInfo) && !currentpmConversationNick && !notifications &&
                    <p className="name-top room">{(currentRoomInfo.name || currentRoomInfo.roomid)}<br/>
                        <JoinLeaveButton style="anchor" roomInfo={currentRoomInfo} roomStayed={currentRoomStayed} roomActive={currentRoomActive} />
                    </p>
                }
                {currentpmConversationNick && <p className="name-top pm">{currentpmConversationNick}<br/><span className="label">{currentPmOnlineStatusStr}</span></p>}
                {notifications && <p className="name-top notifications">{lang.notifications}</p>}
                <div className="right-bottom-menu" onClick={this.onRightBottomMenuClick}><span/></div>

            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    let lang = Registry.get('locale');

    let currentpmConversationNick, unreadpmConversationsPresent = false;
    let currentPmOnlineStatusStr = "";

    for (let uid in state.pm.conversations) {
        let pmConversation = state.pm.conversations[uid];
        if (pmConversation.view.hidden) continue;

        if (pmConversation.view.maximized) {
            let user = pmConversation.user;
            currentpmConversationNick = pmConversation.user.nick;
            if (user.chatrooms && user.chatrooms.length > 0) {
                currentPmOnlineStatusStr = user.chatrooms.join(", ");
            } else {
                currentPmOnlineStatusStr = lang.user_disconnected(user);
            }
        }
        unreadpmConversationsPresent = unreadpmConversationsPresent || pmConversation.unread;
    }

    let room = state.rooms[state.visibleChatrooms.roomid];

    return {
        currentRoomInfo: room ? room.info : undefined,
        currentRoomStayed: room ? room.stayed : false,
        currentRoomActive: room ? room.active : false,
        currentpmConversationNick,
        currentPmOnlineStatusStr,
        unreadpmConversationsPresent,
        leftShown: state.sidebars.leftShown,
        rightShown: state.sidebars.rightShown,
        notifications: state.notifications.showNotificationsWindow,
    }
}

export default connect(mapStateToProps)(ContainerCenterHeader);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ContainerCenterHeader/index.js